import {
  Box
} from '@mui/material';
import {
  useEffect,
  useRef,
  useState
} from 'react';
import ChartLine from 'src/sections/_examples/extra/chart-view/chart-line';

import RCMDashboardTable from '../RCMDashboardTable';
import {fetchChartColors} from 'src/utils/chart_utils';
import {generateYearList} from 'src/utils/helperUtils';

const RCMCollectionsComponent = ({data, chartData}: any) => {

  const [chartColors, setChartColors] = useState<any>({});
  const lineChartRef = useRef<any>(null);

  useEffect(() => {
    // Fetch colors after charts are rendered
    const refList: any = [
      {
        ref: lineChartRef,
        type: 'line',
        name: 'line_chart_01'
      }
    ];
    setTimeout(() => {
      /** Function to retrieve chart colors */
      fetchChartColors(setChartColors, refList);
    }, 500);
  }, [chartData]);

  return (
    <>
      <ChartLine
        chartRef={lineChartRef}
        chartOptionsObj={{
          stroke: {curve: 'straight'},
          yaxis: {
            labels: {
              formatter: (value: any) => `$${value}`
            }
          },
          ...chartData?.line_chart_01
        }}
        series={chartData?.line_chart_01?.series ?? []}
      />
      <Box sx={{mt: 5}}>
        <RCMDashboardTable
          data={{
            ...chartData?.table_data_01,
            colors: chartColors.line_chart_01,
            groupedColumn: true,
            columnsList: [
              Object.keys(chartData?.table_data_01?.rows)[0],
              ...generateYearList(data?.from_date, data?.to_date)
            ],
            splitColumnForHeaderWith: '-'
          }}
          valueFormatter={'currency'}
        />
      </Box>
    </>
  );
};

export default RCMCollectionsComponent;
